var throttle = function throttle(fn, threshhold) {
  var last;
  var deferTimer;
  return function throttled() {
    var _this = this;

    for (var _len = arguments.length, argv = new Array(_len), _key = 0; _key < _len; _key++) {
      argv[_key] = arguments[_key];
    }

    var now = +new Date();

    if (last && now < last + threshhold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(_this, argv);
      }, threshhold);
    } else {
      last = now;
      fn.apply(this, argv);
    }
  };
};

export default throttle;